(function () {
  if (window.__dzSwatches) return;
  window.__dzSwatches = true;

  var conRaton = window.matchMedia('(hover: hover)').matches;

  function elegir(muestra) {
    var tarjeta = muestra.closest('.card-wrapper');
    if (!tarjeta) return;
    var foto = tarjeta.querySelector('.card__media img');
    if (!foto) return;
    foto.removeAttribute('loading');
    foto.srcset = muestra.dataset.srcset;
    foto.src = muestra.dataset.src;
    tarjeta.classList.add('dz-cs-elegida');
    tarjeta.querySelectorAll('.dz-cs__i').forEach(function (m) {
      m.classList.toggle('is-on', m === muestra);
    });
    tarjeta.querySelectorAll('a.full-unstyled-link').forEach(function (enlace) {
      enlace.href = muestra.href;
    });
  }

  document.addEventListener('mouseover', function (e) {
    if (!conRaton || !e.target.closest) return;
    var muestra = e.target.closest('.dz-cs__i');
    if (muestra) elegir(muestra);
  });

  document.addEventListener('click', function (e) {
    if (conRaton || !e.target.closest) return;
    var muestra = e.target.closest('.dz-cs__i');
    if (!muestra) return;
    e.preventDefault();
    elegir(muestra);
  });
})();
